/* eslint-disable no-console */
import axios, {AxiosResponse} from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import type {DataLineageRow} from '../../../pages/dataLineage/utils/dataLineageTypes';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';

export interface DataLineageRequestOptions {
  signal?: AbortSignal;
}

export interface DataLineageQueryParams {
  facilityId?: string;
  scope?: '1' | '2' | '3';
  dataBy?: string;
  group?: string;
  emissionFactor?: string;
  urlName?: string;
  sortBy?: 'inputData' | 'siData' | 'yearlyEmissions';
  sortOrder?: 'asc' | 'desc';
  page?: number;
  pageSize?: number;
}

export interface DataLineageListResponse {
  records: DataLineageRow[];
  total: number;
  page: number;
  pageSize: number;
}

export interface DataLineageXlsxPayload {
  companyId: string;
  year: string;
  facilityId?: string;
}

export interface DataLineageXlsxResponse {
  status: 'success' | 'error';
  message: string;
  data?: {url: string; fileName: string};
}

const dataLineage = async (
  year: string,
  query: DataLineageQueryParams = {},
  options?: DataLineageRequestOptions
): Promise<DataLineageListResponse> => {
  const token = useUserStore.getState().userToken;
  const companyID = useCompanyStore.getState().companyId;

  const response = await axios.request({
    method: CRUDMethods.GET,
    url: `${API_BASE_URL}${API_ENDPOINT_JSON.dataLineage}/company/${companyID}/${year}`,
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: query,
    signal: options?.signal
  });

  const data = response.data?.data ?? {};

  return {
    records: data.records ?? [],
    total: data.total ?? 0,
    page: data.page ?? query.page ?? 1,
    pageSize: data.pageSize ?? query.pageSize ?? 10
  };
};

export const dataLineageXlsxExport = async (
  payload: DataLineageXlsxPayload
): Promise<AxiosResponse<DataLineageXlsxResponse>> => {
  const token = useUserStore.getState().userToken;

  return await axios.request<DataLineageXlsxResponse>({
    method: CRUDMethods.POST,
    url: `${API_BASE_URL}${API_ENDPOINT_JSON.dataLineage}/xlsx`,
    headers: {
      Authorization: `Bearer ${token}`
    },
    data: payload
  });
};

export default dataLineage;
